module.exports = __webpack_public_path__ + "static/media/home-category-5.c72f1c07.png";